import { render } from "./deadgateprivacypolicy.vue?vue&type=template&id=46236ff8&scoped=true"
import script from "./deadgateprivacypolicy.vue?vue&type=script&lang=js"
export * from "./deadgateprivacypolicy.vue?vue&type=script&lang=js"

import "./deadgateprivacypolicy.vue?vue&type=style&index=0&id=46236ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46236ff8"]])

export default __exports__